import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { useTheme } from "@/components/ui/theme-provider";

interface CheckboxWithOtherQuestionProps {
  options: string[];
  value: string[];
  onChange: (value: string[]) => void;
}

export const CheckboxWithOtherQuestion = ({ options, value, onChange }: CheckboxWithOtherQuestionProps) => {
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';
  
  const handleCheckboxChange = (option: string, checked: boolean) => {
    if (checked) {
      onChange([...value, option]);
    } else {
      onChange(value.filter((item) => item !== option));
    }
  };

  const handleOtherTextChange = (text: string) => {
    // Remove any existing "Other" option and its text
    const filteredValue = value.filter(item => item !== "Other" && !item.startsWith("Other: "));
    if (text.trim()) {
      onChange([...filteredValue, "Other", `Other: ${text}`]);
    } else {
      onChange(filteredValue);
    }
  };

  const handleCommentChange = (text: string) => {
    // Remove any existing comment
    const filteredValue = value.filter(item => !item.startsWith("Comment: "));
    if (text.trim()) {
      onChange([...filteredValue, `Comment: ${text}`]);
    } else {
      onChange(filteredValue);
    }
  };

  // Get the "Other" text if it exists
  const otherText = value.find(item => item.startsWith("Other: "))?.substring(7) || "";
  // Get the comment text if it exists
  const commentText = value.find(item => item.startsWith("Comment: "))?.substring(9) || "";

  return (
    <div className="space-y-3">
      {options.map((option) => (
        <div key={option} className="flex items-center space-x-2">
          <Checkbox
            id={option}
            checked={value.includes(option)}
            onCheckedChange={(checked) => handleCheckboxChange(option, checked as boolean)}
            className="border-green-500 data-[state=checked]:bg-green-500 data-[state=checked]:text-white"
          />
          <Label htmlFor={option} className="text-foreground">{option}</Label>
        </div>
      ))}
      <div className="flex items-center space-x-2">
        <Checkbox
          id="other"
          checked={value.includes("Other")}
          onCheckedChange={(checked) => handleCheckboxChange("Other", checked as boolean)}
          className="border-green-500 data-[state=checked]:bg-green-500 data-[state=checked]:text-white"
        />
        <Label htmlFor="other" className="text-foreground">Other</Label>
      </div>
      {value.includes("Other") && (
        <Input
          type="text"
          value={otherText}
          onChange={(e) => handleOtherTextChange(e.target.value)}
          className={`mt-2 ${isDarkMode ? 'bg-[#121a2e]' : 'bg-white'} border-green-500/30 text-foreground focus:border-green-500 focus:ring-green-500 text-base md:text-sm h-12 md:h-10`}
          placeholder="Please specify..."
        />
      )}
      <div className="mt-4">
        <Input
          type="text"
          value={commentText}
          onChange={(e) => handleCommentChange(e.target.value)}
          className={`${isDarkMode ? 'bg-[#121a2e]' : 'bg-white'} border-green-500/30 text-foreground focus:border-green-500 focus:ring-green-500 text-base md:text-sm h-12 md:h-10`}
          placeholder="Any additional comments..."
        />
      </div>
    </div>
  );
}; 